'use client';

import { ThemeProvider } from '@mui/material';
import { ReactNode, useMemo } from 'react';

import { useAppLanguageStore } from '@/features/i18n/useAppLanguageStore';
import { muiMaterialTheme } from '@/theme/muiMaterialTheme';
import { useGetThemeConfig } from '@/theme/useGetThemeConfig';

type Props = {
  children: ReactNode;
};

export const AppThemeProvider = ({ children }: Props) => {
  const [themeConfig, themeMode] = useGetThemeConfig();
  const appLanguage = useAppLanguageStore(state => state.appLanguage);

  const muiTheme = useMemo(
    () => muiMaterialTheme(appLanguage, themeMode, themeConfig),
    [appLanguage, themeConfig, themeMode]
  );

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};
